import Cancel from '../components/cancel/cancel.vue'
import Delayed from '../components/delayed/delayed.vue'
import Confirmed from '../components/confirmed/confirmed.vue'
import Absent from '../components/absent/absent.vue'
import Present from '../components/present/present.vue'
import Rollback from '../components/rollback/rollback'
import RollbackFromDelayed from '../components/rollback-from-delayed/rollback'
import AppointmentDetails from '../components/consultations-made/appointment-details'
import InAttendance from '../components/in-attendance/in-attendance.vue'
import Transfer from '../components/transfer/transfer.vue'

export default {
  AppointmentDetails,
  Cancel,
  Delayed,
  Confirmed,
  Absent,
  InAttendance,
  Present,
  Rollback,
  RollbackFromDelayed,
  Transfer
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/resources/components.js